import { useEffect, useRef } from "react";
import "pannellum/build/pannellum.css";
import "pannellum/build/pannellum.js";
import "./EspacoPage.css";

export default function EspacoPage() {
  const viewerRef = useRef(null);
  const pannellumRef = useRef(null);

  useEffect(() => {
    if (!viewerRef.current || !window.pannellum) return;

    pannellumRef.current = window.pannellum.viewer(viewerRef.current, {
      default: {
        firstScene: "scene1",
        sceneFadeDuration: 800,
        autoLoad: true,
        showZoomCtrl: true,
      },

      scenes: {
        scene1: {
          title: "Entrada",
          panorama: "/assets/images/360/1.png",
          pitch: 0,
          yaw: 120,
          hfov: 110,
          hotSpots: [
            {
              pitch: -5,
              yaw: 130,
              type: "scene",
              text: "Ir para a mesa",
              sceneId: "scene2",
            },
          ],
        },

        scene2: {
          title: "Mesa de atendimento",
          panorama: "/assets/images/360/2.png",
          pitch: 0,
          yaw: 160,
          hfov: 110,
          hotSpots: [
            {
              pitch: -5,
              yaw: 80,
              type: "scene",
              text: "Ir para a maca",
              sceneId: "scene3",
            },
            {
              pitch: -5,
              yaw: 240,
              type: "scene",
              text: "Voltar para entrada",
              sceneId: "scene1",
            },
          ],
        },

        scene3: {
          title: "Maca",
          panorama: "/assets/images/360/3.png",
          pitch: 0,
          yaw: 140,
          hfov: 110,
          hotSpots: [
            {
              pitch: -5,
              yaw: 95,
              type: "scene",
              text: "Ir para a pia",
              sceneId: "scene4",
            },
            {
              pitch: -5,
              yaw: 260,
              type: "scene",
              text: "Voltar para mesa",
              sceneId: "scene2",
            },
          ],
        },

        scene4: {
          title: "Pia",
          panorama: "/assets/images/360/4.png",
          pitch: 0,
          yaw: 120,
          hfov: 110,
          hotSpots: [
            {
              pitch: -5,
              yaw: 250,
              type: "scene",
              text: "Voltar para a maca",
              sceneId: "scene3",
            },
          ],
        },
      },
    });

    return () => {
      if (pannellumRef.current) {
        pannellumRef.current.destroy();
        pannellumRef.current = null;
      }
    };
  }, []);

  return (
    <main className="space-page">
      <section className="space-hero">
        <div className="container">
          <div className="space-hero__content">
            <span className="section-eyebrow">Tour do espaço</span>
            <h1>Conheça o ambiente por dentro</h1>
            <p>
              Explore o espaço da Dionara em 360° e conheça cada detalhe do
              ambiente preparado para o seu atendimento.
            </p>
          </div>
        </div>
      </section>

      <section className="space-tour">
        <div className="container">
          <div className="space-tour__wrapper">
            <div ref={viewerRef} className="space-tour__viewer" />
          </div>
        </div>
      </section>
    </main>
  );
}